/** 404 page for the catch-all `path: '*'` route — a thin ErrorPage wrapper. */
import ErrorPage from '@/features/error/ErrorPage';

export default function NotFoundPage(): JSX.Element {
  return (
    <ErrorPage
      title="Page Not Found"
      message="The page you're looking for doesn't exist or has moved."
      showRetry={false}
      retryHref="/"
    />
  );
}
